module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAhCAYAAAA74pBqAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADHSURBVEhL7da9CsIwFIbhKFjvIFs3N1FHXfzFwWsWRCdBDHQraoeMWdpNEEqoGjkRJW3TQzvmXZJ8wzOn1dsFT9JQbTgbyWH4HIbPYfgchs9h+Cph18UwgGtpVuy2HJ2TJJmF0/4EpsJKMQXFcbyilN49zzvZwELsMh8cNQQTsYG5mIKEEOtfSFcGGpiGfN9/wGRUBP5hb+hgg3R54BdTEOd8UwXSGaD6BUkp91EUdWFCl6bp+PObyrJsWwfSKZAwxjrwrhkhL3OeWcKYMyUJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/FO/resources/img/ribbon-active.png
// module id = 329
// module chunks = 0